<script lang="ts">
	import { symbols } from './lib/store';
  import RequestForm from "./components/RequestForm.svelte";

	let filter = "";
	let filteredSymbols: string[] = [];
	let selectedSymbol = '';
	let openTrade = false;

	function filterSymbols() {
		setTimeout(() => {
			console.log('filtering', filter)
			if(filter.trim().length == 0) {
				filteredSymbols = [];
				return;
			}
			filteredSymbols = $symbols.filter(x => x.toLowerCase().includes(filter.toLowerCase()));
			console.log('filtered', filteredSymbols);
		},0);
	}

	function closeTradeWindow() {
		console.log(arguments);	
		openTrade = false;	
	}

	function openTradeWindow(symbol: string) {
		selectedSymbol = symbol;
		openTrade = true;
	}
</script>

<main>
	<section>
		{#if !openTrade}
		<input type="text" class="symbol-filter" bind:value={filter} on:keyup={filterSymbols} />


		<div class="filtered-symbols">
			{#each filteredSymbols as symbol}
				<button on:click={e => openTradeWindow(symbol)}>{symbol}</button>
			{/each}
		</div>
	{:else}
		<RequestForm on:close={closeTradeWindow} symbol={selectedSymbol}/>
	{/if}
	</section>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	section {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		flex: 0.6;
		width: 100%;
	}

	.filtered-symbols {
		display: flex;
		flex-direction: column;
		margin-top: 1rem;
		width:  100%;
	}

	.filtered-symbols > button {
		align-items: center;
		background-color: aquamarine;
		display: flex;
		height: 2.5rem;
		justify-content: center;
		margin-top: 0.25rem;
		width: 100%;
	}

	.filtered-symbols > button:hover {
		background-color: chartreuse;
		cursor: pointer;
	}

	.symbol-filter {
		border: 2px solid black;
		font-size: x-large;
		height: 2rem;
		width: 100%;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
